<template>
    <v-overlay style="z-index: 9999" scroll-strategy="none" class="align-center justify-center" :model-value="loadingSpinnerState.visible">
        <v-progress-circular size="64" color="primary" indeterminate></v-progress-circular>
    </v-overlay>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import { NAME as NAME_LOADINGSPINNER } from '@/store/modules/loadingSpinner';
const loadingSpinnerModul = namespace(NAME_LOADINGSPINNER);
import { ILoadingSpinnerState } from '@/store/modules/loadingSpinner/state';

@Component
export default class LoadingSpinner extends Vue {
    @loadingSpinnerModul.State((state) => state) loadingSpinnerState!: ILoadingSpinnerState;
}
</script>

<style scoped>
.v-progress-circular {
    width: 100%;
}
</style>
